module.exports = __webpack_public_path__ + "img/maljarno-kuzovnoe-oborudovanie.a794a675.svg";